import type { TOC } from '@ember/component/template-only'
import { type AssessmentScoresRexRoute } from 'teacher-ui-client/reporting/ui-scope/rex/assessment-scores/route'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { array } from '@ember/helper'
import { not } from 'ember-truth-helpers'
import { AssessmentScoresAverages } from 'teacher-ui-client/components/giraffe/charts/assessment-scores/averages'
import { AssessmentScoresByGenreHistory } from 'teacher-ui-client/components/giraffe/charts/assessment-scores/history-by-genre'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { Precinct } from 'teacher-ui-client/utils/precincts'

interface Signature {
  model: ModelFor<AssessmentScoresRexRoute>
}

export const RexAssessmentScoresByGenre: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.assessmentScores.rex"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.assessmentScoresAverages}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.assessmentScoresAverages}}>
    {{#each @model.assessmentScoresAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <AssessmentScoresAverages
          @data={{gradeData}}
          @title={{t "reporting.chartTitles.assessmentScoresAverages.rex"}}
          @grade={{fullGradeName gradeData.grade_position}}
          @precinct={{Precinct.REX_READING}}
          @tooltip={{t "reporting.tooltips.assessmentScoresAverages.rex"}}
        />
      </div>
    {{/each}}
    {{#if @model.assessmentScoresHistory}}
      <AssessmentScoresByGenreHistory
        data-test-assessment-scores-history
        @tooltip={{t "reporting.tooltips.assessmentScoresHistory.rex" htmlSafe=true}}
        @assessmentScoresHistoryData={{@model.assessmentScoresHistory}}
        @subco={{(isSubco)}}
        @uiScope={{@model.uiScope.scope}}
        @students={{@model.scopedStudents}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(RexAssessmentScoresByGenre)
